(function () {
  'use strict';

  if (window.FlorameShopifyAccountUi && window.FlorameShopifyAccountUi.loaded) return;

  var ACCOUNT_SELECTOR = 'shopify-account[data-florame-shopify-account]';
  var LAZY_ACCOUNT_SELECTOR = '[data-florame-shopify-account-lazy]';
  var observedRoots = typeof WeakSet === 'function' ? new WeakSet() : null;
  var emailRequestedAccounts = typeof WeakSet === 'function' ? new WeakSet() : null;
  var emailRequestedRoots = typeof WeakSet === 'function' ? new WeakSet() : null;
  var marketingConsentReviewedRoots = typeof WeakSet === 'function' ? new WeakSet() : null;
  var swipeBoundDialogs = typeof WeakSet === 'function' ? new WeakSet() : null;
  var shopAttemptBoundRoots = typeof WeakSet === 'function' ? new WeakSet() : null;
  var pendingOpen = null;
  var scheduled = false;
  var viewportScheduled = false;
  var SHOP_ATTEMPT_KEY = 'florame_shop_login_attempted_at';
  var emailFormRoots = typeof WeakSet === 'function' ? new WeakSet() : null;
  var loginTransitions = [];

  function recordLoginState(account, state) {
    if (!account || account.getAttribute('data-florame-login-state') === state) return;
    account.setAttribute('data-florame-login-state', state);
    loginTransitions.push({ state: state, at: Date.now() });
    if (loginTransitions.length > 16) loginTransitions.shift();
  }
  var ACCOUNT_OPEN_TIMEOUT_MS = 6000;

  function isItalian() {
    var language = String(document.documentElement.lang || navigator.language || 'it').toLowerCase();
    return language.indexOf('it') === 0;
  }

  function isWebView() {
    // The current Android shell is native and does not load Capacitor.
    if (window.FlorameAndroid || (window.FlorameNativePort && typeof window.FlorameNativePort.postMessage === 'function')) return true;
    if (window.FlorameNative && window.FlorameNative.isNative) return true;
    try {
      if (window.Capacitor && typeof window.Capacitor.isNativePlatform === 'function' && window.Capacitor.isNativePlatform()) return true;
      if (window.Capacitor && typeof window.Capacitor.getPlatform === 'function' && /^(android|ios)$/.test(window.Capacitor.getPlatform())) return true;
    } catch (_) {}
    if (window.ReactNativeWebView && typeof window.ReactNativeWebView.postMessage === 'function') return true;
    var ua = String(navigator.userAgent || '');
    var androidWebView = /FlorameAndroid\//i.test(ua) || /;\s*wv\)/i.test(ua) || (/Android/i.test(ua) && /Version\/4\.0/i.test(ua));
    var iosDevice = /iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1);
    var iosBrowser = /Safari|CriOS|FxiOS|EdgiOS|OPiOS/i.test(ua);
    var iosWebView = iosDevice && /AppleWebKit/i.test(ua) && !iosBrowser;
    return androidWebView || iosWebView || /FBAN|FBAV|Instagram|\bLine\//i.test(ua);
  }

  function isMobileViewport() {
    return window.matchMedia ? window.matchMedia('(max-width: 989px)').matches : window.innerWidth <= 989;
  }

  function appendStyle(root, id, css) {
    if (!root || root.querySelector('style[data-florame-style="' + id + '"]')) return;
    // Shopify's shadow roots do not receive page selectors. Extend our existing
    // component stylesheet only on operational pages; authentication stays Shopify-owned.
    if (root.host && (document.documentElement.getAttribute('data-florame-ui') === 'unified' || document.documentElement.hasAttribute('data-florame-marketplace-home'))) {
      css += '\n' + [
        ':host { font-family: var(--ui-font, FlorameInter, Inter, system-ui); color: var(--ui-ink, #282126); }',
        'dialog.dialog { background: var(--ui-surface, #fff) !important; color: var(--ui-ink, #282126) !important; border: 1px solid var(--ui-line, #e9e2e6) !important; border-radius: 28px !important; }',
        '.account, .account__header, .account__content, .login-form__root { font-family: var(--ui-font, FlorameInter, Inter, system-ui) !important; background: var(--ui-surface, #fff) !important; color: var(--ui-ink, #282126) !important; }',
        '.login-form__email-input-wrapper { position: relative !important; box-sizing: border-box !important; min-height: 60px !important; padding: 0 !important; border: 1px solid #ded8dc !important; border-radius: 22px !important; box-shadow: none !important; }',
        '.login-form__email-input-wrapper:focus-within { border-color: var(--ui-brand, #ff4d75) !important; box-shadow: 0 0 0 3px #ff4d751a !important; }',
        '.login-form__email-input { box-sizing: border-box !important; min-width: 0 !important; width: 100% !important; min-height: 58px !important; padding-right: 68px !important; border: 0 !important; border-radius: inherit !important; background: transparent !important; box-shadow: none !important; }',
        '.login-form__email-input:focus-visible { outline: none !important; }',
        '.login-form__email-submit, [data-florame-email-switch="primary"] { background-color: var(--ui-brand, #ff4d75) !important; background-image: var(--ui-action-gradient, radial-gradient(circle at 18% -50%,rgba(255,255,255,.48),transparent 42%),linear-gradient(118deg,#ff5a8d 0%,#ff2f6d 42%,#d91452 100%)) !important; color: #fff !important; border: 1px solid rgba(255,255,255,.48) !important; border-radius: 22px !important; min-height: 54px !important; padding: 14px 20px !important; font-size: 16px !important; font-weight: 900 !important; line-height: 1.3 !important; box-shadow: var(--ui-action-shadow, 0 20px 46px rgba(214,20,82,.3),0 7px 18px rgba(63,4,25,.14),inset 0 1px 0 rgba(255,255,255,.58),inset 0 -2px 0 rgba(105,0,38,.2)) !important; }',
        '.login-form__email-submit { position: absolute !important; inset: 50% 5px auto auto !important; transform: translateY(-50%) !important; box-shadow: 0 4px 12px #d9145226, inset 0 1px 0 #ffffff70 !important; padding: 0 !important; width: 48px !important; min-width: 48px !important; height: 48px !important; min-height: 48px !important; border-radius: 18px !important; display: grid !important; place-items: center !important; flex-shrink: 0 !important; }',
        '.login-form__email-submit:active:not(:disabled) { transform: translateY(-50%) scale(.96) !important; }',
        '.login-form__email-submit svg { width: 20px !important; height: 20px !important; color: inherit !important; }',
        '.login-form__email-submit:disabled, [data-florame-email-switch="primary"]:disabled { background-image: none !important; background-color: #ededee !important; color: #66666e !important; box-shadow: none !important; }',
        '@media(forced-colors:active) { .login-form__email-submit, [data-florame-email-switch="primary"] { background: ButtonFace !important; color: ButtonText !important; border-color: ButtonText !important; } }',
        '.account__close, [data-testid="login-button"], [data-florame-shop-action="secondary"], .login-form__social-login-button { border-radius: 14px !important; background: #fff !important; color: var(--ui-ink, #282126) !important; box-shadow: none !important; }',
        '.florame-account-primary-action, .florame-account-guest-assistant { border: 1px solid var(--ui-line, #e9e2e6) !important; border-radius: 14px !important; background: var(--ui-surface, #fff) !important; box-shadow: none !important; }',
        '.florame-account-primary-action__icon, .florame-account-guest-assistant__icon { background: var(--ui-brand-soft, #fff0f4) !important; color: var(--ui-brand, #ff4d75) !important; box-shadow: none !important; }',
        'button:focus-visible, a:focus-visible, input:not(.login-form__email-input):focus-visible { outline: 3px solid var(--ui-brand, #ff4d75) !important; outline-offset: 3px !important; }',
        '.florame-account-guest-assistant__copy em { white-space: normal !important; overflow: visible !important; }',
        '.account__heading { font: 750 24px/1.2 var(--ui-font, FlorameInter, Inter, system-ui) !important; letter-spacing: -.035em !important; }',
        '@media(max-width:989px) { dialog.dialog { border-radius: 28px 28px 0 0 !important; } }',
        // Geometry belongs to single-surface below, including the visual viewport.
      ].join('\n');
    }
    var style = document.createElement('style');
    style.setAttribute('data-florame-style', id);
    style.textContent = css;
    root.appendChild(style);
  }

  function normalizedText(element) {
    return String(element && element.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function isRendered(element) {
    if (!element || !element.getBoundingClientRect) return false;
    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && (!element.getClientRects || element.getClientRects().length > 0);
  }

  function accountDialog(account) {
    return account && account.shadowRoot ? account.shadowRoot.querySelector('dialog.dialog, dialog') : null;
  }

  function accountIsOpen(account) {
    var dialog = accountDialog(account);
    return !!(dialog && dialog.open);
  }

  function accountPriority(account) {
    if (!account || !account.isConnected) return -1;
    if (accountIsOpen(account)) return 1000;
    var variant = String(account.getAttribute('data-florame-shopify-account') || 'header');
    var score = isRendered(account) ? 100 : 0;
    if (isMobileViewport() && variant === 'bottom-nav') score += 40;
    else if (!isMobileViewport() && (variant === 'header' || variant === 'home-topbar')) score += 40;
    else if (variant === 'home-profile') score += 20;
    return score;
  }

  function preferredAccount() {
    return Array.prototype.slice.call(document.querySelectorAll(ACCOUNT_SELECTOR))
      .sort(function (left, right) { return accountPriority(right) - accountPriority(left); })[0] || null;
  }

  function lazyAccountPriority(trigger) {
    if (!trigger || !trigger.isConnected) return -1;
    var variant = String(trigger.getAttribute('data-florame-shopify-account-lazy') || 'header');
    var score = isRendered(trigger) ? 100 : 0;
    if (isMobileViewport() && variant === 'bottom-nav') score += 40;
    else if (!isMobileViewport() && (variant === 'header' || variant === 'home-topbar')) score += 40;
    else if (variant === 'home-profile') score += 20;
    return score;
  }

  function preferredLazyAccount() {
    return Array.prototype.slice.call(document.querySelectorAll(LAZY_ACCOUNT_SELECTOR))
      .sort(function (left, right) { return lazyAccountPriority(right) - lazyAccountPriority(left); })[0] || null;
  }

  function hydrateLazyAccount(trigger) {
    if (!trigger || !trigger.isConnected) return Promise.resolve(preferredAccount());
    if (trigger.__florameAccountHydration) return trigger.__florameAccountHydration;

    trigger.setAttribute('aria-busy', 'true');
    trigger.__florameAccountHydration = Promise.resolve().then(function () {
      var template = trigger.nextElementSibling;
      if (!template || !template.matches || !template.matches('template[data-florame-shopify-account-template]')) return null;
      var source = template.content && template.content.querySelector
        ? template.content.querySelector(ACCOUNT_SELECTOR)
        : null;
      if (!source) return null;
      var account = source.cloneNode(true);
      setSignInReturn(account);
      if (trigger.hasAttribute('data-florame-account-trigger')) {
        account.setAttribute('data-florame-auth-portal', '');
        // The navigation capsule has transforms/backdrop filters. Mount the SDK
        // host outside it so Safari hit testing and the modal viewport agree.
        // Keep a real box: display:contents breaks the dialog top layer in WebKit.
        account.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;contain:none;';
        var avatar = account.querySelector('[slot="signed-out-avatar"]');
        if (avatar) avatar.hidden = true;
        account.addEventListener('close', function () { if (trigger.isConnected) trigger.focus({ preventScroll: true }); });
        document.body.appendChild(account);
      } else trigger.replaceWith(account);
      template.remove();
      schedule();
      return account;
    }).catch(function () {
      return null;
    }).finally(function () {
      if (trigger.isConnected) trigger.removeAttribute('aria-busy');
    });
    return trigger.__florameAccountHydration;
  }

  function signedOutTrigger(account) {
    if (!account) return null;
    var slotted = account.querySelector('[slot="signed-out-avatar"]');
    if (slotted && typeof slotted.click === 'function') return slotted;
    if (!account.shadowRoot) return null;
    return account.shadowRoot.querySelector('button[part~="signed-out-avatar"], [part~="signed-out-avatar"]');
  }

  function activateAccount(account) {
    return new Promise(function (resolve) {
      if (!account) { resolve(false); return; }
      if (accountIsOpen(account)) { resolve(true); return; }

      var settled = false;
      var retryTimer = 0;
      var timeoutTimer = 0;
      var trigger = signedOutTrigger(account);

      function finish(opened) {
        if (settled) return;
        settled = true;
        account.removeEventListener('open', onOpen);
        if (retryTimer) window.clearTimeout(retryTimer);
        if (timeoutTimer) window.clearTimeout(timeoutTimer);
        resolve(!!opened);
      }

      function onOpen() { finish(true); }
      account.addEventListener('open', onOpen, { once: true });
      // The custom element can be registered before its shadow button is mounted.
      // Activate once it is ready; a second click can toggle an opening sheet closed.
      var activated = false;
      function tryActivate() {
        if (settled) return;
        if (accountIsOpen(account)) { finish(true); return; }
        var internal = account.shadowRoot
          ? account.shadowRoot.querySelector('button[part~="signed-out-avatar"], [part~="signed-out-avatar"]')
          : null;
        if (internal && !activated) {
          activated = true;
          try { (trigger || internal).click(); } catch (_) { finish(false); return; }
        }
        retryTimer = window.setTimeout(tryActivate, 80);
      }
      timeoutTimer = window.setTimeout(function () { finish(accountIsOpen(account)); }, ACCOUNT_OPEN_TIMEOUT_MS);
      tryActivate();
    });
  }

  function openAccount(options) {
    if (pendingOpen) return pendingOpen;
    var opts = options || {};
    var sourceTrigger = opts.trigger || null;

    function openReadyAccount(account) {
      account = account || preferredAccount();
      if (!account) return Promise.resolve(false);
      setSignInReturn(account, opts.returnTo);
      return activateAccount(account).then(function (opened) {
        if (opened) {
          schedule();
          try {
            window.dispatchEvent(new CustomEvent('florame:shopify-account-opened', {
              detail: { sourceTrigger: sourceTrigger || null }
            }));
          } catch (_) {}
        }
        return opened;
      });
    }

    var lazyTrigger = sourceTrigger && sourceTrigger.closest ? sourceTrigger.closest(LAZY_ACCOUNT_SELECTOR) : null;
    var accountPromise = preferredAccount()
      ? Promise.resolve(preferredAccount())
      : hydrateLazyAccount(lazyTrigger || preferredLazyAccount());

    pendingOpen = accountPromise.then(function (account) {
      if (!account) return false;
      if (!window.customElements || typeof window.customElements.whenDefined !== 'function') return openReadyAccount(account);
      if (window.customElements.get && window.customElements.get('shopify-account')) return openReadyAccount(account);
      return new Promise(function (resolve) {
        var settled = false;
        var timer = window.setTimeout(function () { settled = true; resolve(false); }, ACCOUNT_OPEN_TIMEOUT_MS);
        window.customElements.whenDefined('shopify-account').then(function () {
          if (settled) return;
          settled = true;
          window.clearTimeout(timer);
          resolve(openReadyAccount(account));
        }).catch(function () { window.clearTimeout(timer); resolve(false); });
      });
    }).then(function (opened) {
      pendingOpen = null;
      return opened;
    }, function () {
      pendingOpen = null;
      return false;
    });
    return pendingOpen;
  }

  function isEmailSwitchText(text) {
    return text === 'use email instead'
      || text === 'usa email'
      || text === "usa l'email"
      || text === 'usa l\u2019email';
  }

  function isShopActionText(text) {
    return text === 'sign in with shop'
      || text === 'continue with shop'
      || text === 'log in with shop'
      || text === 'accedi con shop'
      || text === 'continua con shop';
  }

  function shouldAutoOpenEmail() {
    // Shopify swaps and remounts the login subtree asynchronously. Clicking its
    // "use email" control during that transition causes visible jumps, stale
    // recognition state and, on some devices, a stuck Shop spinner. Keep the
    // email action visually primary and let the customer choose it explicitly.
    return false;
  }

  function owningAccount(node) {
    var current = node && node.host ? node.host : node;
    var guard = 0;
    while (current && guard < 12) {
      if (current.matches && current.matches(ACCOUNT_SELECTOR)) return current;
      var tree = current.getRootNode ? current.getRootNode() : null;
      if (tree && tree.host) current = tree.host;
      else current = current.parentElement;
      guard += 1;
    }
    return null;
  }

  function accountEmailInput(account) {
    if (!account || !account.shadowRoot) return null;
    var loginForm = account.shadowRoot.querySelector('shopify-login-form');
    if (!loginForm || !loginForm.shadowRoot) return null;
    var emailInput = loginForm.shadowRoot.querySelector('input[type="email"], input[autocomplete="email"]');
    return isRendered(emailInput) ? emailInput : null;
  }

  function activeDeepElement() {
    var active = document.activeElement;
    var guard = 0;
    while (active && active.shadowRoot && active.shadowRoot.activeElement && guard < 12) {
      active = active.shadowRoot.activeElement;
      guard += 1;
    }
    return active;
  }

  function isTextEntryActive() {
    var active = activeDeepElement();
    if (!active) return false;
    return active.tagName === 'INPUT' || active.tagName === 'TEXTAREA' || active.isContentEditable;
  }

  function translateEmailSwitch(candidate) {
    if (!candidate || !isItalian()) return;
    candidate.setAttribute('aria-label', 'Usa l\u2019email');
    candidate.setAttribute('data-florame-email-switch', 'primary');
    var translated = false;
    Array.prototype.forEach.call(candidate.childNodes || [], function (node) {
      if (node.nodeType !== 3 || !isEmailSwitchText(String(node.nodeValue || '').replace(/\s+/g, ' ').trim().toLowerCase())) return;
      if (node.nodeValue !== 'Usa l\u2019email') node.nodeValue = 'Usa l\u2019email';
      translated = true;
    });
    Array.prototype.forEach.call(candidate.querySelectorAll('*'), function (element) {
      if (element.children.length > 0 || !isEmailSwitchText(normalizedText(element))) return;
      if (element.textContent !== 'Usa l\u2019email') element.textContent = 'Usa l\u2019email';
      translated = true;
    });
    if (!translated && isEmailSwitchText(normalizedText(candidate))) candidate.textContent = 'Usa l\u2019email';
  }

  function markShopActions(root) {
    if (!root || !root.querySelectorAll) return;
    var controls = root.querySelectorAll('button, a, [role="button"]');
    Array.prototype.forEach.call(controls, function (control) {
      if (!isShopActionText(normalizedText(control)) && control.getAttribute('data-testid') !== 'login-button') return;
      control.setAttribute('data-florame-shop-action', 'secondary');
      control.hidden = isWebView();
      if (control.hidden) control.style.setProperty('display', 'none', 'important');
    });
  }

  function rememberShopAttempt() {
    try { window.sessionStorage.setItem(SHOP_ATTEMPT_KEY, String(Date.now())); } catch (_) {}
  }

  function pendingShopAttemptAt() {
    try { return Number(window.sessionStorage.getItem(SHOP_ATTEMPT_KEY) || 0); } catch (_) { return 0; }
  }

  function clearShopAttempt() {
    try { window.sessionStorage.removeItem(SHOP_ATTEMPT_KEY); } catch (_) {}
  }

  function bindShopAttemptRecovery(root) {
    if (!root || !root.addEventListener) return;
    if (shopAttemptBoundRoots && shopAttemptBoundRoots.has(root)) return;
    if (shopAttemptBoundRoots) shopAttemptBoundRoots.add(root);
    root.addEventListener('click', function (event) {
      var control = event.target && event.target.closest
        ? event.target.closest('[data-testid="login-button"], [data-florame-shop-action="secondary"]')
        : null;
      if (!control || (!isShopActionText(normalizedText(control)) && control.getAttribute('data-testid') !== 'login-button')) return;
      if (isWebView()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      rememberShopAttempt();
    }, true);
  }

  function resetShopVisualState(root) {
    if (!root || !root.querySelectorAll) return;
    Array.prototype.forEach.call(root.querySelectorAll('[data-testid="shop-login-spinner"]'), function (spinner) {
      spinner.setAttribute('data-visible', 'false');
      spinner.setAttribute('aria-hidden', 'true');
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-testid="login-button"]'), function (button) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    });
  }

  function recoverCancelledShopAttempt() {
    var attemptedAt = pendingShopAttemptAt();
    if (!attemptedAt || Date.now() - attemptedAt < 450 || document.visibilityState === 'hidden') return;
    clearShopAttempt();
    Array.prototype.forEach.call(document.querySelectorAll(ACCOUNT_SELECTOR), function (account) {
      if (!account.shadowRoot) return;
      var root = account.shadowRoot;
      Array.prototype.forEach.call(root.querySelectorAll('shop-login'), function (shopLogin) {
        if (shopLogin.shadowRoot) resetShopVisualState(shopLogin.shadowRoot);
      });
      var dialog = root.querySelector('dialog');
      if (dialog && dialog.open) closeFromSwipe(dialog, root);
    });
  }

  function requestEmailFirst(root) {
    if (!root || !root.querySelectorAll) return;
    var account = owningAccount(root);
    var candidates = root.querySelectorAll('button, a, [role="button"]');
    for (var index = 0; index < candidates.length; index += 1) {
      var candidate = candidates[index];
      var text = normalizedText(candidate);
      if (!isEmailSwitchText(text)) continue;

      translateEmailSwitch(candidate);
      if (!shouldAutoOpenEmail(account, candidate)) break;
      if ((account && accountEmailInput(account)) || isTextEntryActive()) break;
      if (account && emailRequestedAccounts && emailRequestedAccounts.has(account)) break;
      if (!account && emailRequestedRoots && emailRequestedRoots.has(root)) break;
      if (account && emailRequestedAccounts) emailRequestedAccounts.add(account);
      else if (emailRequestedRoots) emailRequestedRoots.add(root);
      try { candidate.click(); } catch (_) {}
      break;
    }
  }

  function styleShopLogin(shopLogin) {
    if (!shopLogin || !shopLogin.shadowRoot) return;
    var root = shopLogin.shadowRoot;
    markShopActions(root);
    bindShopAttemptRecovery(root);
    appendStyle(root, 'shop-secondary', [
      '[data-testid="login-button"], [data-florame-shop-action="secondary"] {',
      '  background: #ffffff !important;',
      '  color: #513a43 !important;',
      '  border: 1px solid rgba(81, 58, 67, .18) !important;',
      '  box-shadow: none !important;',
      '}',
      '[data-testid="login-button"] span, [data-florame-shop-action="secondary"] span { color: #513a43 !important; }',
      '[data-testid="login-button"] svg, [data-florame-shop-action="secondary"] svg { color: #513a43 !important; }',
      '[data-testid="login-button"] svg path, [data-florame-shop-action="secondary"] svg path { fill: #513a43 !important; }',
      '[data-testid="login-button"]:hover, [data-florame-shop-action="secondary"]:hover { background: #fff6f9 !important; }',
      '[data-florame-email-switch="primary"] {',
      '  min-height: 54px !important;',
      '  background: #ff4d75 !important;',
      '  color: #ffffff !important;',
      '  border: 1px solid #ff4d75 !important;',
      '  border-radius: 999px !important;',
      '  font-weight: 750 !important;',
      '  box-shadow: 0 10px 24px rgba(255, 77, 117, .22) !important;',
      '  order: -1 !important;',
      '}',
      '[data-florame-email-switch="primary"] span { color: #ffffff !important; }',
      '[data-florame-email-switch="primary"]:hover { background: #e62f61 !important; }'
    ].join('\n'));
    requestEmailFirst(root);
    observeRoot(root);
  }

  function styleLoginForm(loginForm) {
    if (!loginForm || !loginForm.shadowRoot) return;
    var root = loginForm.shadowRoot;
    var divider = root.querySelector('.login-form__divider');
    var googleButtons = root.querySelectorAll('[data-provider="google" i], [data-provider="google.com" i]');
    var webView = isWebView();
    bindEmailForm(loginForm);

    if (!marketingConsentReviewedRoots || !marketingConsentReviewedRoots.has(root)) {
      var marketingConsent = root.querySelector(
        '.login-form__marketing-consent-checkbox, .login-form__marketing-consent input[type="checkbox"], input[name*="marketing"], input[name*="accepts_marketing"]'
      );
      if (marketingConsent) {
        if (marketingConsentReviewedRoots) marketingConsentReviewedRoots.add(root);
        var marketingWasChecked = !!(marketingConsent.checked || marketingConsent.defaultChecked || marketingConsent.hasAttribute('checked'));
        marketingConsent.defaultChecked = false;
        marketingConsent.removeAttribute('checked');
        if (marketingConsent.checked) {
          try { marketingConsent.click(); }
          catch (_) {
            marketingConsent.checked = false;
            try { marketingConsent.dispatchEvent(new Event('change', { bubbles: true, composed: true })); } catch (_) {}
          }
        }
        if (marketingWasChecked && !marketingConsent.checked) {
          try { marketingConsent.dispatchEvent(new Event('input', { bubbles: true, composed: true })); } catch (_) {}
          try { marketingConsent.dispatchEvent(new Event('change', { bubbles: true, composed: true })); } catch (_) {}
        }
        marketingConsent.setAttribute('data-florame-opt-in-default', 'off');
      }
    }

    if (divider) {
      divider.setAttribute('aria-label', isItalian() ? 'oppure' : 'or');
      var dividerText = divider.querySelector('.login-form__divider-text');
      var expectedDividerText = isItalian() ? 'oppure' : 'or';
      if (dividerText && dividerText.textContent !== expectedDividerText) dividerText.textContent = expectedDividerText;
    }
    Array.prototype.forEach.call(googleButtons, function (google) {
      google.hidden = webView;
      var account = owningAccount(loginForm);
      ['href', 'data-url'].forEach(function (attribute) {
        var value = google.getAttribute(attribute);
        if (!value || !account) return;
        try {
          var url = new URL(value, window.location.origin);
          if (url.origin !== window.location.origin) return;
          url.searchParams.set('return_to', safeSignInReturn(account.getAttribute('data-florame-sign-in-return')));
          if (value !== url.href) google.setAttribute(attribute, url.href);
        } catch (_) {}
      });
    });
    // The native bridge may become available after Shopify's first render.
    // A permanent attribute selector also wins against the SDK's display:flex.
    loginForm.toggleAttribute('data-florame-webview', webView);

    appendStyle(root, 'email-first', [
      '.login-form__root { display: flex !important; flex-direction: column !important; gap: 12px !important; }',
      '.login-form__email-form { order: -4; margin: 0 !important; }',
      '.login-form__email-input-wrapper {',
      '  min-height: 56px !important;',
      '  border: 2px solid #ff4d75 !important;',
      '  border-radius: 15px !important;',
      '  box-shadow: 0 8px 24px rgba(255, 77, 117, .12) !important;',
      '}',
      '.login-form__email-input { font-size: 16px !important; }',
      '.login-form__email-submit { background: #ff4d75 !important; color: #ffffff !important; }',
      '.login-form__marketing-consent { order: -3; display: none !important; }',
      '.login-form__divider { order: -2; margin: 2px 0 !important; }',
      '.login-form__divider-text { color: #7a6870 !important; font-size: 12px !important; text-transform: lowercase !important; }',
      '.login-form__social-login-button[data-provider="google"] { background: #ffffff !important; color: #513a43 !important; border: 1px solid rgba(81, 58, 67, .16) !important; box-shadow: none !important; }',
      '.login-form__social-login-button.shop-login svg path { fill: currentColor !important; }',
      ':host([data-florame-webview]) [data-provider="google"], [data-provider="google"][hidden] { display: none !important; }',
      ':host([data-florame-webview]) [data-provider="google.com" i], :host([data-florame-webview]) [data-provider="google" i] { display: none !important; }',
      ':host([data-florame-webview]) .login-form__social-login-button.shop-login, :host([data-florame-webview]) [data-provider="shop" i] { display: none !important; }',
      ':host([data-florame-webview]) .login-form__divider { display: none !important; }'
    ].join('\n'));

    var shopLogin = root.querySelector('shop-login');
    if (shopLogin) styleShopLogin(shopLogin);
    requestEmailFirst(root);
    observeRoot(root);
  }

  function updateViewportMetrics() {
    viewportScheduled = false;
    var accounts = document.querySelectorAll(ACCOUNT_SELECTOR);
    // Do not force a layout of the storefront for a dialog that does not exist.
    if (!accounts.length) return;
    var visual = window.visualViewport;
    var viewportHeight = visual && visual.height ? visual.height : window.innerHeight;
    var viewportTop = visual && typeof visual.offsetTop === 'number' ? visual.offsetTop : 0;
    var layoutHeight = Math.max(window.innerHeight || 0, document.documentElement.clientHeight || 0);
    var viewportBottom = Math.max(0, layoutHeight - viewportHeight - viewportTop);

    Array.prototype.forEach.call(accounts, function (account) {
      account.style.setProperty('--florame-account-viewport-height', Math.round(viewportHeight) + 'px');
      account.style.setProperty('--florame-account-viewport-top', Math.round(viewportTop) + 'px');
      account.style.setProperty('--florame-account-viewport-bottom', Math.round(viewportBottom) + 'px');
      account.style.setProperty('--florame-account-keyboard-inset', Math.round(viewportBottom) + 'px');
      keepFocusedFieldVisible(account);
    });
  }

  function scheduleViewportMetrics() {
    if (viewportScheduled) return;
    viewportScheduled = true;
    window.requestAnimationFrame(updateViewportMetrics);
  }

  function keepFocusedFieldVisible(account) {
    var input = activeDeepElement();
    if (!input || owningAccount(input) !== account || !account.shadowRoot || !isTextEntryActive()) return;
    var content = account.shadowRoot.querySelector('.account__content');
    if (!content || !content.getBoundingClientRect) return;
    var visual = window.visualViewport;
    var visibleTop = visual && visual.offsetTop || 0;
    var visibleBottom = visibleTop + (visual && visual.height || window.innerHeight);
    var inputRect = input.getBoundingClientRect();
    var contentRect = content.getBoundingClientRect();
    var topLimit = Math.max(contentRect.top, visibleTop) + 12;
    var bottomLimit = Math.min(contentRect.bottom, visibleBottom) - 12;
    var delta = 0;
    if (inputRect.top < topLimit) delta = inputRect.top - topLimit;
    else if (inputRect.bottom > bottomLimit) delta = inputRect.bottom - bottomLimit;
    // Keyboard resize/pan already animates the viewport. A second smooth scroll fights it.
    if (Math.abs(delta) >= 2) content.scrollTop += delta;
  }

  function closeFromSwipe(dialog, root) {
    var closeButton = root.querySelector('.account__close, #close-button, button[aria-label*="Chiudi"], button[aria-label*="Close"]');
    captureExitPosition(dialog);
    if (closeButton) { closeButton.click(); return; }
    dialog.classList.remove('is-florame-dragging', 'is-florame-snap-back');
    dialog.style.removeProperty('--florame-account-drag-y');
    if (typeof dialog.close === 'function') dialog.close();
  }

  function captureExitPosition(dialog) {
    var transform = window.getComputedStyle(dialog).transform;
    var y = transform && transform !== 'none' ? new DOMMatrixReadOnly(transform).m42 : 0;
    dialog.style.setProperty('--florame-account-exit-y', Math.max(0, y) + 'px');
  }

  function ensureLoginBenefits(root, hasLogin) {
    // Keep the benefits in the scrolling body, below authentication. The email
    // field stays in place when the keyboard opens or Shopify changes views.
    var region = root.querySelector('.account__content');
    if (!region) return;
    var benefits = region.querySelector('[data-florame-login-benefits]');
    if (!hasLogin) { if (benefits) benefits.hidden = true; return; }
    if (!benefits) {
      var template = document.getElementById('FlorameLoginBenefitsTemplate');
      if (!template || !template.content) return;
      benefits = template.content.querySelector('[data-florame-login-benefits]').cloneNode(true);
      region.appendChild(benefits);
    }
    benefits.hidden = false;
    benefits.setAttribute('aria-label', isItalian() ? 'I vantaggi del tuo account' : 'Your account benefits');
    var labels = isItalian() ? ['I tuoi ordini', 'Preferiti', 'Le tue creazioni', 'Indirizzi salvati'] : ['Your orders', 'Favorites', 'Your creations', 'Saved addresses'];
    var descriptions = isItalian() ? ['Segui ogni bouquet, passo dopo passo.', 'Ritrova i bouquet che ami.', 'Tutti i bouquet creati da te, insieme.', 'I dati di fatturazione già pronti.'] : ['Follow every bouquet, step by step.', 'Find the bouquets you love.', 'All the bouquets you made, together.', 'Your billing details, ready to use.'];
    Array.prototype.forEach.call(benefits.querySelectorAll('li'), function (pill, index) {
      var label = pill.querySelector('strong');
      var description = pill.querySelector('small');
      if (label.textContent !== labels[index]) label.textContent = labels[index];
      if (description.textContent !== descriptions[index]) description.textContent = descriptions[index];
    });
  }

  function guestCopy() {
    if (isItalian()) {
      return {
        benefit: 'Accedi per seguire gli ordini, salvare gli indirizzi e ricevere assistenza più velocemente.',
        club: 'Florame Club',
        clubSub: 'Punti, premi e occasioni da ricordare',
        latest: 'Ultima generazione',
        latestSub: 'Riapri il bouquet più recente',
        assistant: 'Chiedi a Florame',
        assistantSub: 'AI per scegliere, persone per aiutarti',
        language: 'Lingua',
        install: 'Installa Florame',
        help: 'Aiuto e supporto',
        label: 'Strumenti Florame disponibili senza accesso'
      };
    }
    return {
      benefit: 'Sign in to track orders, save addresses and get help faster.',
      club: 'Florame Club',
      clubSub: 'Points, rewards and occasions to remember',
      latest: 'Latest generation',
      latestSub: 'Reopen your most recent bouquet',
      assistant: 'Ask Florame',
      assistantSub: 'AI to choose, people to help',
      language: 'Language',
      install: 'Install Florame',
      help: 'Help and support',
      label: 'Florame tools available without signing in'
    };
  }

  function dispatchGuestUtility(utility) {
    try {
      window.dispatchEvent(new CustomEvent('florame:account-utility', {
        detail: { utility: utility, source: 'shopify-login' }
      }));
    } catch (_) {}
  }

  function hasLastGeneration() {
    var api = window.FlorameAccountCenter;
    return !!(api && typeof api.hasLastGeneration === 'function' && api.hasLastGeneration());
  }

  function clubAvailable() {
    return !!(window.__florameCustomerLoyaltyAvailability && window.__florameCustomerLoyaltyAvailability.enabled === true);
  }

  function ensurePageLockStyle() {
    appendStyle(document.head || document.documentElement, 'page-lock', [
      'html.florame-shopify-account-open, body.florame-shopify-account-open { overflow: hidden !important; overscroll-behavior: none !important; }'
    ].join('\n'));
  }

  function syncPageLock() {
    var open = Array.prototype.some.call(document.querySelectorAll(ACCOUNT_SELECTOR), accountIsOpen);
    document.documentElement.classList.toggle('florame-shopify-account-open', open);
    if (document.body) document.body.classList.toggle('florame-shopify-account-open', open);
  }

  function accountUtilityIcon(kind) {
    if (kind === 'club') return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3 5 6v5c0 4.5 2.8 8 7 10 4.2-2 7-5.5 7-10V6Z"/><path d="M9 12.5 11.2 15 16 9.5"/></svg>';
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m4 20 9.8-9.8"/><path d="M12.5 4.5l.7-2 .7 2 2 .7-2 .7-.7 2-.7-2-2-.7 2-.7Z"/><path d="M18.2 12.8l.6-1.7.6 1.7 1.7.6-1.7.6-.6 1.7-.6-1.7-1.7-.6 1.7-.6Z"/></svg>';
  }

  function ensureAccountTools(root, dialog, hasLogin) {
    if (!root || !dialog) return;
    var content = root.querySelector('.account__content');
    if (!content) return;
    var copy = guestCopy();
    var tools = content.querySelector('[data-florame-guest-tools]');
    if (hasLogin || root.querySelector('[part~="signed-out-avatar"]')) {
      if (tools) tools.hidden = true;
      return;
    }
    if (tools) tools.hidden = false;

    if (!tools) {
      tools = document.createElement('section');
      tools.className = 'florame-account-guest-tools';
      tools.setAttribute('data-florame-guest-tools', '1');
      tools.setAttribute('aria-label', copy.label);

      var primaryActions = document.createElement('div');
      primaryActions.className = 'florame-account-primary-actions';
      ['club', 'latest'].forEach(function (utility) {
        var primary = document.createElement('button');
        primary.type = 'button';
        primary.className = 'florame-account-primary-action florame-account-primary-action--' + utility;
        primary.setAttribute('data-florame-guest-utility', utility === 'latest' ? 'last_generation' : utility);
        var icon = document.createElement('span');
        icon.className = 'florame-account-primary-action__icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.innerHTML = accountUtilityIcon(utility);
        var primaryCopy = document.createElement('span');
        primaryCopy.className = 'florame-account-primary-action__copy';
        primaryCopy.innerHTML = '<strong></strong><small></small>';
        var chevron = document.createElement('span');
        chevron.className = 'florame-account-primary-action__chevron';
        chevron.setAttribute('aria-hidden', 'true');
        chevron.textContent = '›';
        primary.appendChild(icon);
        primary.appendChild(primaryCopy);
        primary.appendChild(chevron);
        primary.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          closeFromSwipe(dialog, root);
          window.setTimeout(function () { dispatchGuestUtility(utility === 'latest' ? 'last_generation' : utility); }, 180);
        });
        primaryActions.appendChild(primary);
      });
      tools.appendChild(primaryActions);

      var assistant = document.createElement('button');
      assistant.type = 'button';
      assistant.className = 'florame-account-guest-assistant';
      assistant.setAttribute('data-florame-guest-utility', 'assistant');
      assistant.setAttribute('aria-label', copy.assistant + '. ' + copy.assistantSub);

      var assistantIcon = document.createElement('span');
      assistantIcon.className = 'florame-account-guest-assistant__icon';
      assistantIcon.setAttribute('aria-hidden', 'true');
      assistantIcon.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m4 20 9.8-9.8"/><path d="M12.5 4.5l.7-2 .7 2 2 .7-2 .7-.7 2-.7-2-2-.7 2-.7Z"/><path d="M18.2 12.8l.6-1.7.6 1.7 1.7.6-1.7.6-.6 1.7-.6-1.7-1.7-.6 1.7-.6Z"/></svg>';

      var assistantCopy = document.createElement('span');
      assistantCopy.className = 'florame-account-guest-assistant__copy';
      var assistantTitle = document.createElement('strong');
      var assistantLabel = document.createElement('span');
      assistantLabel.className = 'florame-account-guest-assistant__label';
      assistantLabel.textContent = copy.assistant;
      assistantTitle.appendChild(assistantLabel);
      var assistantBadge = document.createElement('span');
      assistantBadge.className = 'florame-account-guest-assistant__badge';
      assistantBadge.textContent = 'AI';
      assistantTitle.appendChild(assistantBadge);
      var assistantSub = document.createElement('em');
      assistantSub.textContent = copy.assistantSub;
      assistantCopy.appendChild(assistantTitle);
      assistantCopy.appendChild(assistantSub);

      var assistantChevron = document.createElement('span');
      assistantChevron.className = 'florame-account-guest-assistant__chevron';
      assistantChevron.setAttribute('aria-hidden', 'true');
      assistantChevron.textContent = '›';

      assistant.appendChild(assistantIcon);
      assistant.appendChild(assistantCopy);
      assistant.appendChild(assistantChevron);
      assistant.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        assistant.setAttribute('aria-busy', 'true');
        closeFromSwipe(dialog, root);
        window.setTimeout(function () {
          var inbox = window.FlorameShopifyInbox;
          var opener = inbox && typeof inbox.open === 'function' ? inbox.open : window.openShopifyInboxFromMenu;
          var result = typeof opener === 'function' ? opener() : false;
          Promise.resolve(result).finally(function () { assistant.removeAttribute('aria-busy'); });
        }, 260);
      });
      tools.appendChild(assistant);

      var benefit = document.createElement('p');
      benefit.className = 'florame-account-guest-benefit';
      benefit.textContent = copy.benefit;
      tools.appendChild(benefit);

      var actions = document.createElement('div');
      actions.className = 'florame-account-guest-actions';
      ['language', 'install', 'help'].forEach(function (utility) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'florame-account-guest-action';
        button.setAttribute('data-florame-guest-utility', utility);
        button.textContent = copy[utility];
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (utility === 'install') {
            var api = window.FlorameAccountCenter;
            if (api && typeof api.install === 'function') api.install();
            else dispatchGuestUtility(utility);
            closeFromSwipe(dialog, root);
            return;
          }
          closeFromSwipe(dialog, root);
          window.setTimeout(function () { dispatchGuestUtility(utility); }, 260);
        });
        actions.appendChild(button);
      });
      tools.appendChild(actions);
      content.appendChild(tools);
    }

    tools.setAttribute('aria-label', copy.label);
    tools.setAttribute('data-florame-account-state', hasLogin ? 'guest' : 'customer');
    Array.prototype.forEach.call(tools.querySelectorAll('.florame-account-primary-action'), function (button) {
      var utility = button.getAttribute('data-florame-guest-utility');
      var latest = utility === 'last_generation';
      button.hidden = utility === 'club' ? !clubAvailable() : (latest && !hasLastGeneration());
      var title = button.querySelector('strong');
      var subtitle = button.querySelector('small');
      if (title && title.textContent !== (latest ? copy.latest : copy.club)) title.textContent = latest ? copy.latest : copy.club;
      if (subtitle && subtitle.textContent !== (latest ? copy.latestSub : copy.clubSub)) subtitle.textContent = latest ? copy.latestSub : copy.clubSub;
      button.setAttribute('aria-label', (latest ? copy.latest : copy.club) + '. ' + (latest ? copy.latestSub : copy.clubSub));
    });
    var benefitCopy = tools.querySelector('.florame-account-guest-benefit');
    if (benefitCopy && benefitCopy.textContent !== copy.benefit) benefitCopy.textContent = copy.benefit;
    var assistantButton = tools.querySelector('.florame-account-guest-assistant');
    if (assistantButton) {
      assistantButton.setAttribute('aria-label', copy.assistant + '. ' + copy.assistantSub);
      var assistantTitleCopy = assistantButton.querySelector('.florame-account-guest-assistant__label');
      var assistantSubCopy = assistantButton.querySelector('.florame-account-guest-assistant__copy em');
      if (assistantTitleCopy && assistantTitleCopy.textContent !== copy.assistant) assistantTitleCopy.textContent = copy.assistant;
      if (assistantSubCopy && assistantSubCopy.textContent !== copy.assistantSub) assistantSubCopy.textContent = copy.assistantSub;
    }
    Array.prototype.forEach.call(tools.querySelectorAll('[data-florame-guest-utility]'), function (button) {
      var utility = button.getAttribute('data-florame-guest-utility');
      var hasStructuredCopy = utility === 'club' || utility === 'last_generation';
      if (utility !== 'assistant' && !hasStructuredCopy && button.textContent !== (copy[utility] || utility)) button.textContent = copy[utility] || utility;
      if (utility !== 'install') return;
      var api = window.FlorameAccountCenter;
      button.hidden = !!(api && typeof api.canInstall === 'function' && !api.canInstall());
    });
  }

  function bindSwipeToClose(account, root, dialog) {
    if (!dialog || !root) return;
    if (swipeBoundDialogs && swipeBoundDialogs.has(dialog)) return;
    if (swipeBoundDialogs) swipeBoundDialogs.add(dialog);

    // Focusing an email field can resize/reposition the sheet between down and
    // up. A tap that started inside must not become a Shopify backdrop click.
    var pointerStartedInside = false;
    dialog.addEventListener('pointerdown', function (event) {
      pointerStartedInside = event.composedPath().some(function (node) {
        return node && node.classList && node.classList.contains('account');
      });
    }, true);
    dialog.addEventListener('click', function (event) {
      var startedInside = pointerStartedInside;
      pointerStartedInside = false;
      if (startedInside && event.target === dialog) event.stopImmediatePropagation();
    }, true);

    var surface = root.querySelector('.account__header') || dialog;
    var tracking = false;
    var startY = 0;
    var position = 0;
    var velocity = 0;
    var frame = 0;
    var samples = [];
    var pointerId = null;

    function paint() {
      dialog.style.setProperty('--florame-account-drag-y', position.toFixed(2) + 'px');
    }

    function stopSpring() {
      if (frame) window.cancelAnimationFrame(frame);
      frame = 0;
    }

    function settle() {
      stopSpring();
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced) position = velocity = 0;
      var previous = performance.now();
      function step(now) {
        var dt = Math.min(.032, Math.max(.001, (now - previous) / 1000));
        previous = now;
        velocity += (-420 * position - 41 * velocity) * dt;
        position = Math.max(0, position + velocity * dt);
        paint();
        if (!dialog.open || (position < .2 && Math.abs(velocity) < 4)) {
          position = velocity = frame = 0;
          dialog.classList.remove('is-florame-dragging');
          dialog.style.removeProperty('--florame-account-drag-y');
          return;
        }
        frame = window.requestAnimationFrame(step);
      }
      frame = window.requestAnimationFrame(step);
    }

    function shouldIgnore(target) {
      return !!(target && target.closest && target.closest('button, a, input, textarea, select, [contenteditable="true"]'));
    }

    function start(y, target) {
      if (!dialog.open || !isMobileViewport() || shouldIgnore(target)) return false;
      // Capture the presented position, including an interrupted opening or spring.
      captureExitPosition(dialog);
      position = parseFloat(dialog.style.getPropertyValue('--florame-account-exit-y')) || 0;
      stopSpring();
      tracking = true;
      startY = y - position;
      samples = [{ y: y, time: performance.now() }];
      dialog.classList.remove('is-florame-snap-back');
      dialog.setAttribute('data-florame-entered', '');
      dialog.classList.add('is-florame-dragging');
      paint();
      return true;
    }

    function move(y, event) {
      if (!tracking) return;
      position = Math.max(0, y - startY);
      var now = performance.now();
      samples.push({ y: y, time: now });
      samples = samples.filter(function (sample) { return now - sample.time <= 100; });
      paint();
      if (position > 0 && event && event.cancelable) event.preventDefault();
    }

    function finish(cancelled) {
      if (!tracking) return;
      tracking = false;
      var first = samples[0], last = samples[samples.length - 1];
      velocity = !cancelled && first && last && performance.now() - last.time < 100
        ? (last.y - first.y) * 1000 / Math.max(16, last.time - first.time) : 0;
      var threshold = Math.min(112, Math.max(72, window.innerHeight * 0.12));

      if (!cancelled && (position >= threshold || (position >= 36 && position + velocity * .16 >= threshold))) {
        closeFromSwipe(dialog, root);
        return;
      }
      settle();
    }

    if (window.PointerEvent) {
      surface.addEventListener('pointerdown', function (event) {
        if (!event.isPrimary || !start(event.clientY, event.target)) return;
        pointerId = event.pointerId;
        if (surface.setPointerCapture) {
          try { surface.setPointerCapture(event.pointerId); } catch (_) {}
        }
      });
      surface.addEventListener('pointermove', function (event) { if (event.pointerId === pointerId) move(event.clientY, event); }, { passive: false });
      surface.addEventListener('pointerup', function (event) { if (event.pointerId === pointerId) finish(false); });
      surface.addEventListener('pointercancel', function (event) { if (event.pointerId === pointerId) finish(true); });
      surface.addEventListener('lostpointercapture', function () { finish(true); });
    } else {
      surface.addEventListener('touchstart', function (event) {
        if (event.touches && event.touches[0]) start(event.touches[0].clientY, event.target);
      }, { passive: true });
      surface.addEventListener('touchmove', function (event) {
        if (event.touches && event.touches[0]) move(event.touches[0].clientY, event);
      }, { passive: false });
      surface.addEventListener('touchend', function () { finish(false); });
      surface.addEventListener('touchcancel', function () { finish(true); });
    }

    root.addEventListener('click', function (event) {
      if (!event.target.closest || !event.target.closest('.account__close')) return;
      captureExitPosition(dialog);
      stopSpring();
      tracking = false;
      dialog.classList.remove('is-florame-dragging');
    }, true);
    dialog.addEventListener('close', function () {
      stopSpring();
      tracking = false;
      position = velocity = 0;
      dialog.classList.remove('is-florame-dragging');
      dialog.style.removeProperty('--florame-account-drag-y');
      dialog.style.removeProperty('--florame-account-exit-y');
      dialog.removeAttribute('data-florame-entered');
    });

    account.setAttribute('data-florame-swipe-ready', '1');
  }

  function safeSignInReturn(value) {
    var fallback = window.location.pathname + window.location.search + window.location.hash;
    function localPath(candidate) {
      var text = String(candidate || '');
      if (/\\|[\u0000-\u001f]/.test(text)) return '';
      try {
        var url = new URL(text, window.location.origin);
        if (url.origin !== window.location.origin || url.username || url.password || url.pathname.indexOf('//') === 0) return '';
        if (/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/(account|authentication|customer_authentication|customer_identity)(?:\/|$)/i.test(url.pathname)) return '';
        return url.pathname + url.search + url.hash;
      } catch (_) { return ''; }
    }
    return (value ? localPath(value) : '') || localPath(fallback) || '/';
  }

  function bindEmailForm(loginForm) {
    var root = loginForm.shadowRoot;
    if (!root || (emailFormRoots && emailFormRoots.has(root))) return;
    if (emailFormRoots) emailFormRoots.add(root);
    // The SDK's custom absolute sign-in URL renders the normal email form
    // without attaching Shop's recognition slot. Keep Shopify-owned inputs.
    loginForm.popupLogin = false;
    // A late bridge can arrive after Shopify attached its discovery element.
    // Disconnect that slot and suppress its queued callbacks; keep the input.
    Array.prototype.forEach.call(loginForm.querySelectorAll('shop-login'), function (shop) {
      ['loaded', 'lookup_start', 'lookup_end', 'shop_user_matched'].forEach(function (name) {
        shop.addEventListener(name, function (event) { event.stopImmediatePropagation(); }, true);
      });
      shop.remove();
    });
    root.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches('.login-form__email-form')) return;
      var email = form.querySelector('input[type="email"], input[autocomplete="email"]');
      if (!email || !email.value.trim() || !email.checkValidity()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      var account = owningAccount(loginForm);
      if (account && account.getAttribute('data-florame-login-state') === 'submitting') return;
      var url = new URL('/customer_authentication/login', window.location.origin);
      url.searchParams.set('return_to', safeSignInReturn(account && account.getAttribute('data-florame-sign-in-return')));
      url.searchParams.set('login_hint', email.value.trim());
      url.searchParams.set('login_hint_mode', 'submit');
      var language = loginForm.language || document.documentElement.lang;
      if (language) url.searchParams.set('locale', language.replace('_', '-'));
      if (/^[a-z]{2}$/i.test(loginForm.country || '')) url.searchParams.set('region_country', loginForm.country.toUpperCase());
      var consent = root.querySelector('.login-form__marketing-consent-checkbox');
      if (consent) url.searchParams.set('marketing_consent', consent.checked ? 'true' : 'false');
      recordLoginState(account, 'submitting');
      try { window.location.assign(url.href); }
      catch (_) { recordLoginState(account, 'error'); }
    }, true);
    root.addEventListener('input', function (event) {
      var email = event.target;
      if (!email || !email.matches('input[type="email"]')) return;
      // Avoid the SDK lookup on input, including in the late-bridge case.
      event.stopImmediatePropagation();
      var submit = root.querySelector('.login-form__email-submit');
      if (submit) submit.disabled = !email.value.trim() || !email.checkValidity();
      recordLoginState(owningAccount(loginForm), 'email');
    }, true);
    var currentEmail = root.querySelector('input[type="email"]');
    var currentSubmit = root.querySelector('.login-form__email-submit');
    if (currentEmail && currentSubmit) currentSubmit.disabled = !currentEmail.value.trim() || !currentEmail.checkValidity();
    recordLoginState(owningAccount(loginForm), 'email');
  }

  function setSignInReturn(account, value) {
    if (!value && !account.getAttribute('data-florame-sign-in-return')) {
      try { value = new URL(account.getAttribute('sign-in-url'), window.location.origin).searchParams.get('return_to'); } catch (_) {}
    }
    var destination = safeSignInReturn(value || account.getAttribute('data-florame-sign-in-return'));
    // Query-free absolute URLs opt out of the SDK's embedded Shop discovery.
    // Email submit adds supported hints and the full return exactly once.
    // Shop discovery replaces the input when it loads, losing typed focus.
    account.setAttribute('data-florame-sign-in-return', destination);
    var url = new URL('/customer_authentication/login', window.location.origin).href;
    if (account.getAttribute('sign-in-url') !== url) account.setAttribute('sign-in-url', url);
  }

  function personalizeAccount(account) {
    if (!account) return;
    if (!account.hasAttribute('sign-in-url') || (isWebView() && !account.hasAttribute('data-florame-sign-in-return'))) setSignInReturn(account);
    account.toggleAttribute('data-florame-native-login', isWebView());
    if (account.hasAttribute('data-florame-auth-portal') && account.shadowRoot) {
      appendStyle(account.shadowRoot, 'portal-avatar', '[part~="signed-out-avatar"], [part~="signed-in-avatar"] { display: none !important; } dialog { pointer-events: auto !important; }');
    }
    if (account.getAttribute('data-florame-account-bound') !== '1') {
      account.setAttribute('data-florame-account-bound', '1');
      // Late shadow-root attachment does not emit a child-list mutation on its host.
      if (window.customElements && typeof window.customElements.whenDefined === 'function') {
        ['shopify-login-form', 'shop-login'].forEach(function (name) {
          window.customElements.whenDefined(name).then(schedule).catch(function () {});
        });
      }
      account.addEventListener('open', function () {
        recordLoginState(account, 'opening');
        if (emailRequestedAccounts) emailRequestedAccounts.delete(account);
        syncPageLock();
        scheduleViewportMetrics();
        schedule();
      });
      account.addEventListener('close', function () {
        recordLoginState(account, 'closed');
        window.requestAnimationFrame(syncPageLock);
      });
    }
    if (!account.shadowRoot) return;
    var root = account.shadowRoot;
    var dialog = root.querySelector('dialog');
    var loginLoader = root.querySelector('shopify-login-form-loader');
    var loginForm = root.querySelector('shopify-login-form');
    var shopLogin = root.querySelector('shop-login');
    var menuRegion = root.querySelector('.account__menu-region');
    var hasLogin = !!(loginLoader || loginForm || shopLogin);
    account.toggleAttribute('data-florame-login-active', hasLogin);
    ensureLoginBenefits(root, hasLogin);

    if (dialog && !dialog.open && emailRequestedAccounts) emailRequestedAccounts.delete(account);
    if (menuRegion) menuRegion.hidden = hasLogin;
    var heading = root.querySelector('.account__heading');
    if (hasLogin && heading && /^(Accedi o crea un account|Sign in or create an account|Accedi a Florame|Sign in to Florame)$/.test(heading.textContent.trim())) {
      var title = isItalian() ? 'Accedi a Florame' : 'Sign in to Florame';
      if (heading.textContent !== title) heading.textContent = title;
    }
    appendStyle(root, 'single-surface', [
      // One sizing model for the shell, header and scrolling content. dvh alone excludes the keyboard.
      'dialog.dialog { position: fixed !important; box-sizing: border-box !important; inset: var(--florame-account-viewport-top, 0px) 0 var(--florame-account-viewport-bottom, 0px) !important; margin: auto !important; width: min(440px, calc(100% - 32px)) !important; max-width: calc(100% - 32px) !important; height: fit-content !important; min-height: 0 !important; max-height: max(0px, calc(var(--florame-account-viewport-height, 100dvh) - 24px)) !important; padding: 0 !important; overflow: hidden !important; }',
      '.account { display: flex !important; flex-direction: column !important; box-sizing: border-box !important; height: auto !important; min-height: 0 !important; max-height: max(0px, calc(var(--florame-account-viewport-height, 100dvh) - 26px)) !important; overflow: hidden !important; }',
      'dialog.dialog::backdrop { background: rgba(40, 25, 33, .24); pointer-events: auto !important; }',
      'dialog.dialog[open] { animation-duration: 340ms; animation-timing-function: cubic-bezier(.22,1,.36,1); }',
      'dialog.dialog.closing { animation-duration: 220ms; animation-timing-function: cubic-bezier(.4,0,1,1); }',
      'dialog.dialog[data-florame-entered][open]:not(.closing) { animation: none !important; }',
      '.enter-right, .enter-left { --transition-amount: 16px !important; animation-timing-function: cubic-bezier(.22,1,.36,1) !important; }',
      '.account__close { touch-action: manipulation; transition: transform 120ms ease-out !important; }',
      '.account__close:active { transform: scale(.94); }',
      '[data-florame-login-benefits] { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; margin: 20px 0 0; padding: 0; list-style: none; }',
      '[data-florame-login-benefits][hidden] { display: none !important; }',
      '[data-florame-login-benefits] li { display: grid; grid-template-columns: 40px minmax(0, 1fr); align-content: start; align-items: center; gap: 8px; box-sizing: border-box; min-width: 0; padding: 12px; border: 1px solid #eee3e8; border-radius: 22px; background: linear-gradient(140deg, #fff, var(--benefit-surface)); color: #402a35; font-family: var(--ui-font, FlorameInter, Inter, system-ui); box-shadow: inset 0 1px 0 #fff, 0 3px 8px rgb(54 36 47 / .035); }',
      '.florame-login-benefit--orders { --menu-icon-ink: #207c65; --menu-icon-tint: #dbf3e9; --menu-icon-shade: #91c6b5; --benefit-surface: #f0faf5; }',
      '.florame-login-benefit--heart { --menu-icon-ink: #b43362; --menu-icon-tint: #fbe1eb; --menu-icon-shade: #dda1b7; --benefit-surface: #fff2f7; }',
      '.florame-login-benefit--bouquet { --menu-icon-ink: #88702a; --menu-icon-tint: #f8efcf; --menu-icon-shade: #d0c28c; --benefit-surface: #fffbef; }',
      '.florame-login-benefit--profile { --menu-icon-ink: #6651b1; --menu-icon-tint: #eae3fb; --menu-icon-shade: #b7a4df; --benefit-surface: #f6f3ff; }',
      '.florame-login-benefit__bubble { display: grid; place-items: center; box-sizing: border-box; width: 40px; height: 40px; border: 1px solid rgb(255 255 255 / .85); border-radius: 50%; color: var(--menu-icon-ink); background: radial-gradient(ellipse at 28% 18%, #fff 0%, var(--menu-icon-tint) 66%, var(--menu-icon-shade) 140%); box-shadow: inset 1px 2px 3px #fff, inset -1px -2px 3px var(--menu-icon-shade), 0 2px 3px rgb(54 36 47 / .1); }',
      '.florame-login-benefit__bubble svg { display: block; width: 22px; height: 22px; }',
      '[data-florame-login-benefits] strong { min-width: 0; color: #402a35; font-size: 13px; font-weight: 750; line-height: 1.25; overflow-wrap: break-word; }',
      '[data-florame-login-benefits] small { grid-column: 1 / -1; color: #71616a; font-size: 12px; font-weight: 500; line-height: 1.4; overflow-wrap: break-word; }',
      '@media (max-width: 359px) { [data-florame-login-benefits] { gap: 8px; } [data-florame-login-benefits] li { padding: 10px; grid-template-columns: 1fr; } }',
      '@media (forced-colors: active) { [data-florame-login-benefits] li, .florame-login-benefit__bubble { border-color: CanvasText; background: Canvas; color: CanvasText; box-shadow: none; } [data-florame-login-benefits] strong, [data-florame-login-benefits] small { color: CanvasText; } }',
      '.account__header-region { flex: 0 0 auto !important; height: auto !important; min-height: 0 !important; }',
      '.account__header { position: relative !important; box-sizing: border-box !important; display: flex !important; align-items: center !important; gap: 12px !important; height: auto !important; min-height: 76px !important; padding: 20px 20px 12px !important; }',
      '.account__header-content { flex: 1 1 auto !important; min-width: 0 !important; }',
      '.account__heading { margin: 0 !important; overflow-wrap: break-word; }',
      '.account__close { flex: 0 0 44px !important; width: 44px !important; min-width: 44px !important; height: 44px !important; min-height: 44px !important; padding: 0 !important; }',
      '.account__content { margin: 0 !important; flex: 0 1 auto !important; box-sizing: border-box !important; height: auto !important; min-height: 0 !important; padding: 8px 20px max(24px, env(safe-area-inset-bottom)) !important; overflow: hidden auto !important; overscroll-behavior: contain; scroll-padding: 12px 0 16px; touch-action: pan-y; -webkit-overflow-scrolling: touch; }',
      '.account__login-slot { margin-bottom: 0 !important; }',
      '.account__menu-region[hidden] { display: none !important; }',
      '.florame-account-guest-tools[hidden] { display: none !important; }',
      '.florame-account-guest-tools { margin: 14px 2px 0; padding-top: 12px; border-top: 1px solid #f2ecea; }',
      '.florame-account-primary-actions { display: grid; gap: 8px; margin-bottom: 9px; }',
      '.florame-account-primary-action { display: grid; grid-template-columns: 38px minmax(0, 1fr) 18px; align-items: center; gap: 10px; width: 100%; min-height: 58px; padding: 9px 11px; border: 1px solid rgba(77, 132, 203, .2); border-radius: 15px; background: linear-gradient(118deg, rgba(238,247,255,.96), rgba(255,255,255,.98)); color: #26232a; text-align: left; cursor: pointer; touch-action: manipulation; box-shadow: 0 8px 20px rgba(40,83,130,.08); }',
      '.florame-account-primary-action--club { border-color: rgba(53,145,103,.2); background: linear-gradient(118deg, rgba(235,250,243,.98), rgba(255,255,255,.98)); }',
      '.florame-account-primary-action__icon { display: grid; place-items: center; width: 38px; height: 38px; border-radius: 12px; background: #e9f4ff; color: #397dc5; }',
      '.florame-account-primary-action--club .florame-account-primary-action__icon { background: #e7f7ef; color: #218c62; }',
      '.florame-account-primary-action__icon svg { width: 20px; height: 20px; fill: none; stroke: currentColor; stroke-width: 1.8; stroke-linecap: round; stroke-linejoin: round; }',
      '.florame-account-primary-action__copy { display: grid; min-width: 0; gap: 2px; }',
      '.florame-account-primary-action__copy strong { font-size: 14px; font-weight: 820; line-height: 1.18; }',
      '.florame-account-primary-action__copy small { color: #6d656b; font-size: 11.5px; font-weight: 570; line-height: 1.3; }',
      '.florame-account-primary-action__chevron { color: #8b858a; font-size: 22px; line-height: 1; }',
      '.florame-account-primary-action[hidden] { display: none !important; }',
      '.florame-account-guest-tools[data-florame-account-state="customer"] .florame-account-guest-benefit { display: none; }',
      '.florame-account-guest-assistant { display: grid; grid-template-columns: 34px minmax(0, 1fr) 20px; align-items: center; gap: 11px; width: 100%; min-height: 58px; padding: 9px 10px; border: 0; border-radius: 11px; background: linear-gradient(90deg, #fff0f4, rgba(255,255,255,0) 82%); box-shadow: none; color: #2b2226; text-align: left; cursor: pointer; touch-action: manipulation; transition: background-color .16s ease, transform .16s ease; }',
      '.florame-account-guest-assistant__icon { display: grid; place-items: center; width: 34px; height: 34px; border: 0; border-radius: 11px; background: linear-gradient(135deg, #ed356a, #ff7067); box-shadow: none; color: #fff; }',
      '.florame-account-guest-assistant__icon svg { width: 18px; height: 18px; fill: none; stroke: currentColor; stroke-width: 1.8; stroke-linecap: round; stroke-linejoin: round; }',
      '.florame-account-guest-assistant__copy { display: grid; min-width: 0; gap: 2px; }',
      '.florame-account-guest-assistant__copy strong { display: flex; align-items: center; gap: 7px; color: #2f2026; font-size: 14px; font-weight: 820; line-height: 1.2; }',
      '.florame-account-guest-assistant__badge { display: inline-flex; align-items: center; min-height: 18px; padding: 2px 6px; border: 1px solid rgba(237,53,106,.2); border-radius: 999px; background: #fff; color: #b92755; font-size: 9px; font-weight: 900; letter-spacing: .06em; line-height: 1; }',
      '.florame-account-guest-assistant__copy em { overflow: hidden; color: #705e65; font-size: 12px; font-style: normal; font-weight: 580; line-height: 1.35; text-overflow: ellipsis; white-space: nowrap; }',
      '.florame-account-guest-assistant__chevron { display: grid; place-items: center; width: 20px; height: 30px; background: transparent; color: #9d9298; font-size: 22px; font-weight: 500; line-height: 1; }',
      '.florame-account-guest-assistant:hover { background: linear-gradient(90deg, #ffe8ef, #fff 82%); transform: translateY(-1px); }',
      '.florame-account-guest-assistant:focus-visible { outline: 3px solid rgba(255, 77, 117, .34); outline-offset: 3px; }',
      '.florame-account-guest-assistant[aria-busy="true"] { opacity: .72; pointer-events: none; }',
      '.florame-account-guest-benefit { margin: 0; padding: 5px 12px 9px 56px; border-radius: 0; background: transparent; color: #786a70; font-size: 11.5px; font-weight: 560; line-height: 1.4; text-align: left; }',
      '.florame-account-guest-actions { display: grid; grid-template-columns: repeat(auto-fit, minmax(92px, 1fr)); gap: 1px; margin-top: 7px; overflow: hidden; border: 1px solid rgba(81, 58, 67, .12); border-radius: 13px; background: rgba(81, 58, 67, .12); }',
      '.florame-account-guest-action { min-width: 0; min-height: 44px; padding: 8px 7px; border: 0; border-radius: 0; background: #ffffff; color: #513a43; font: inherit; font-size: 13px; font-weight: 720; line-height: 1.2; cursor: pointer; touch-action: manipulation; }',
      '.florame-account-guest-action:hover { background: #fff7f9; }',
      '.florame-account-guest-action:focus-visible { position: relative; z-index: 1; outline: 2px solid #ff4d75; outline-offset: -2px; }',
      '.florame-account-guest-action[hidden] { display: none !important; }',
      '@media (max-width: 989px) {',
      '  dialog.dialog {',
      '    inset-block-start: auto !important;',
      '    inset-block-end: var(--florame-account-viewport-bottom, 0px) !important;',
      '    top: auto !important;',
      '    bottom: var(--florame-account-viewport-bottom, 0px) !important;',
      '    width: 100% !important; max-width: 100% !important; height: auto !important;',
      '    min-height: 0 !important;',
      '    max-height: calc(var(--florame-account-viewport-height, 100dvh) - 12px) !important;',
      '    margin: 0 !important;',
      '    border-radius: 24px 24px 0 0 !important;',
      '    --dialog-drawer-opening-animation: account-drawer-slide-in;',
      '    --dialog-drawer-closing-animation: account-drawer-slide-out;',
      '  }',
      '  .account { max-height: max(0px, calc(var(--florame-account-viewport-height, 100dvh) - 14px)) !important; }',
      '  :host([data-florame-native-login][data-florame-login-active]) dialog.dialog { min-height: min(360px, calc(var(--florame-account-viewport-height, 100dvh) - 12px)) !important; }',
      '  :host([data-florame-native-login][data-florame-login-active]) .account { min-height: min(358px, calc(var(--florame-account-viewport-height, 100dvh) - 14px)) !important; }',
      '  .account__header { padding-top: 24px !important; touch-action: none; }',
      '  .account__close { width: 44px !important; min-width: 44px !important; height: 44px !important; min-height: 44px !important; }',
      '  .account__header::before {',
      '    content: "";',
      '    position: absolute;',
      '    top: 7px;',
      '    left: 50%;',
      '    width: 42px;',
      '    height: 5px;',
      '    border-radius: 999px;',
      '    background: rgba(21, 32, 25, .24);',
      '    transform: translateX(-50%);',
      '  }',
      '  dialog.dialog.is-florame-dragging { animation: none !important; transition: none !important; opacity: 1 !important; transform: translate3d(0, var(--florame-account-drag-y, 0px), 0) !important; will-change: transform; }',
      '  dialog.dialog.is-florame-snap-back { transition: transform 180ms ease-out !important; transform: translate3d(0, 0, 0) !important; }',
      '}',
      '@keyframes account-drawer-slide-in { from { transform: translateY(56px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }',
      '@keyframes account-drawer-slide-out { from { transform: translateY(var(--florame-account-exit-y, 0px)); opacity: 1; } to { transform: translateY(calc(var(--florame-account-exit-y, 0px) + 56px)); opacity: 0; } }',
      '@media (prefers-reduced-motion: reduce) { dialog.dialog[open], dialog.dialog.closing, .enter-right, .enter-left { animation: none !important; } dialog.dialog.is-florame-snap-back, .account__close { transition: none !important; } }'
    ].join('\n'));

    if (dialog) bindSwipeToClose(account, root, dialog);
    if (loginForm) styleLoginForm(loginForm);
    if (dialog) ensureAccountTools(root, dialog, hasLogin);
    requestEmailFirst(root);
    observeRoot(root);
    syncPageLock();
  }

  function inspectTree(root) {
    if (!root || !root.querySelectorAll) return;
    Array.prototype.forEach.call(root.querySelectorAll(ACCOUNT_SELECTOR), personalizeAccount);
    if (root.host && root.host.matches && root.host.matches(ACCOUNT_SELECTOR)) personalizeAccount(root.host);

    Array.prototype.forEach.call(root.querySelectorAll('*'), function (element) {
      if (element.shadowRoot) {
        if (element.tagName === 'SHOPIFY-LOGIN-FORM') styleLoginForm(element);
        else if (element.tagName === 'SHOP-LOGIN') styleShopLogin(element);
        requestEmailFirst(element.shadowRoot);
        observeRoot(element.shadowRoot);
        inspectTree(element.shadowRoot);
      }
    });
  }

  function run() {
    scheduled = false;
    ensurePageLockStyle();
    // Shopify's nested shadow roots belong to the account, not to product grids.
    Array.prototype.forEach.call(document.querySelectorAll(ACCOUNT_SELECTOR), function (account) {
      personalizeAccount(account);
      if (account.shadowRoot) inspectTree(account.shadowRoot);
    });
    scheduleViewportMetrics();
    syncPageLock();
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(run);
  }

  function observeRoot(root) {
    if (!root || !window.MutationObserver) return;
    if (observedRoots && observedRoots.has(root)) return;
    if (observedRoots) observedRoots.add(root);
    var observer = new MutationObserver(function (records) {
      if (root.host) { schedule(); return; }
      var accountChanged = records.some(function (record) {
        if (record.target.closest && record.target.closest(ACCOUNT_SELECTOR)) return true;
        return Array.prototype.some.call(record.addedNodes, containsAccount)
          || Array.prototype.some.call(record.removedNodes, containsAccount);
      });
      if (accountChanged) schedule();
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  function containsAccount(node) {
    return node && node.nodeType === 1 && (node.matches(ACCOUNT_SELECTOR) || node.querySelector(ACCOUNT_SELECTOR));
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target && event.target.closest ? event.target.closest(LAZY_ACCOUNT_SELECTOR) : null;
    if (!trigger) return;
    if (trigger.hasAttribute('data-florame-account-trigger')) return;
    event.preventDefault();
    event.stopPropagation();
    var returnTo = window.location.pathname + window.location.search + window.location.hash;
    openAccount({ trigger: trigger }).then(function (opened) {
      if (opened) return;
      window.location.assign('/customer_authentication/login?return_to=' + encodeURIComponent(safeSignInReturn(returnTo)));
    }).catch(function () {
      window.location.assign('/customer_authentication/login?return_to=' + encodeURIComponent(safeSignInReturn(returnTo)));
    });
  }, true);

  document.addEventListener('open', function (event) {
    var account = event.target && event.target.closest ? event.target.closest(ACCOUNT_SELECTOR) : null;
    if (account && emailRequestedAccounts) emailRequestedAccounts.delete(account);
    if (account) personalizeAccount(account);
    schedule();
  }, true);
  document.addEventListener('focusin', function (event) {
    var path = event.composedPath ? event.composedPath() : [];
    var insideAccount = path.some ? path.some(function (node) {
      return node && node.matches && node.matches(ACCOUNT_SELECTOR);
    }) : false;
    if (!insideAccount) return;
    scheduleViewportMetrics();
    window.setTimeout(scheduleViewportMetrics, 80);
    window.setTimeout(scheduleViewportMetrics, 280);
    window.setTimeout(function () {
      Array.prototype.forEach.call(document.querySelectorAll(ACCOUNT_SELECTOR), keepFocusedFieldVisible);
    }, 360);
  }, true);
  window.addEventListener('resize', scheduleViewportMetrics, { passive: true });
  window.addEventListener('orientationchange', scheduleViewportMetrics, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleViewportMetrics, { passive: true });
    window.visualViewport.addEventListener('scroll', scheduleViewportMetrics, { passive: true });
  }
  window.addEventListener('florame:native-ready', schedule);
  window.addEventListener('florame:native-auth', function (event) {
    var state = event.detail && event.detail.status;
    if (state !== 'signed_in' && state !== 'signed_out') return;
    Array.prototype.forEach.call(document.querySelectorAll(ACCOUNT_SELECTOR), function (account) {
      recordLoginState(account, state === 'signed_in' ? 'authenticated' : 'closed');
    });
  });
  window.addEventListener('florame:native-auth-error', function () {
    Array.prototype.forEach.call(document.querySelectorAll(ACCOUNT_SELECTOR), function (account) { recordLoginState(account, 'error'); });
  });
  window.addEventListener('florame:pwa-install-state', schedule);
  window.addEventListener('florame:last-generation-persisted', schedule);
  window.addEventListener('florame:last-generation-restored', schedule);
  window.addEventListener('florame:loyalty-availability', schedule);
  window.addEventListener('florame:background-loading-change', schedule);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted && isWebView()) {
      Array.prototype.forEach.call(document.querySelectorAll(ACCOUNT_SELECTOR), function (account) {
        if (account.getAttribute('data-florame-login-state') === 'submitting') recordLoginState(account, 'email');
      });
    }
    window.setTimeout(recoverCancelledShopAttempt, 120);
  });
  window.addEventListener('focus', function () { window.setTimeout(recoverCancelledShopAttempt, 120); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') window.setTimeout(recoverCancelledShopAttempt, 120);
  });
  observeRoot(document.documentElement);
  if (document.querySelector(ACCOUNT_SELECTOR) && window.customElements && typeof window.customElements.whenDefined === 'function') {
    window.customElements.whenDefined('shopify-account').then(run).catch(function () {});
  }

  window.FlorameShopifyAccountUi = {
    loaded: true,
    version: '1.13.0',
    diagnostics: function () { return loginTransitions.slice(); },
    refresh: run,
    isWebView: isWebView,
    open: openAccount,
    isOpen: function () { return Array.prototype.some.call(document.querySelectorAll(ACCOUNT_SELECTOR), accountIsOpen); }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
  window.setTimeout(run, 300);
})();
